import { keepPreviousData } from '@tanstack/react-query';

import { RequestForQuoteViewFilterMessage } from '../../../../types/RequestForQuoteViewFilterMessage';
import { RequestForQuoteViewGatewayMessage } from '../../../../types/RequestForQuoteViewGatewayMessage';
import { queries } from '../../../common/api/queryKeys/queries';
import { usePaginationQuery } from '../../../common/hooks/usePaginationQuery';

export const useRfqPagination = ({ page = 0, ...rest }: RequestForQuoteViewFilterMessage) => {
    const nextPage = queries.requestsForQuotes.pagination({ page: page + 1, ...rest });

    return usePaginationQuery<RequestForQuoteViewGatewayMessage>({
        ...queries.requestsForQuotes.pagination({ page, ...rest }),
        options: { placeholderData: keepPreviousData },
        prefetchQueryKey: nextPage.queryKey,
        prefetchQueryFn: nextPage.queryFn,
    });
};
